import styles from "./DeleteEmptyGroupsModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import GroupsList from "../GroupsList";

/**
 *
 * Modal used in the groups page to delete all empty groups.
 */

export function DeleteEmptyGroupsModal({
  header,
  description,
  btnName,
  isOpen,
  onClose,
  onClick,
  groupsList,
}) {
  if (!isOpen) {
    return "";
  }
  return (
    <>
      <div className={styles.modalBackground} onClick={onClose} />
      <div className={styles.container}>
        <div className={classNames(styles.header)}>{header}</div>
        <div className={styles.hr} />
        <div className={styles.description}>{description}</div>
        <GroupsList groups={groupsList} empty={true} />

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button className={classNames(styles.button)} onClick={onClick}>
            {btnName}
          </button>
        </div>
      </div>
    </>
  );
}

DeleteEmptyGroupsModal.propTypes = {
  header: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  description: PropTypes.string,
  btnName: PropTypes.string,
  groupsList: PropTypes.arrayOf(PropTypes.object),
};
